export default __webpack_public_path__ + "static/globalmap2022-2-01-sp-e5c4a176313cc372461354a89113b37c.svg";